const AboutTheCompanyTemplate = ({children}) =>
    <div>
        <p>
            {children}
        </p>
    </div>

export default AboutTheCompanyTemplate;
